const PORTAL_PREFIXES = ["admin", "counsel", "eas", "vals", "lacw", "jbl", "rga"];

export function getRequestedPortal(pathname = "") {
  const path = String(pathname).toLowerCase();
  if (path === "/inbox") return "admin";

  return PORTAL_PREFIXES.find((portal) =>
    path === `/${portal}-portal` || path.startsWith(`/${portal}-`)
  ) || null;
}

export function canAccessPortal(user, requestedPortal) {
  if (!requestedPortal) return true;
  if (!user) return false;
  if (user.role === "admin") return true;
  return Boolean(user.portal) && user.portal === requestedPortal;
}
